import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import CardsSection from '@/pages/home/components/CardsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FaqSection from '@/pages/home/components/FaqSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AppSection from '@/pages/home/components/AppSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <RankingSection />
        <MediaSection />
        <FaqSection />
        <TopicsSection />
        <IndexSection />
        <UpdatesSection />
        <AppSection />
        <ContactSection />
        <AboutSection />
        <CarouselSection />
        <FeaturesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}